import { ReactNode } from 'react'

import { Layout } from 'antd'

const { Content } = Layout

export interface LayoutContentProps {
  children: ReactNode
}

export const LayoutContent = (props: LayoutContentProps) => {
  const { children } = props

  return (
    <Content style={{ margin: '84px 20px 40px 20px' }}>
      <div
        className="site-layout-background"
        style={{
          minHeight: 360,
          height: '100%',
          backgroundColor: '#fff',
          padding: 40
        }}
      >
        {children}
      </div>
    </Content>
  )
}
